import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import LatestReveal from './components/LatestReveal';
import DailyHighlights from './components/DailyHighlights';
import TrendingGrid from './components/TrendingGrid';
import ExclusiveReveal from './components/ExclusiveReveal';
import BrandSection from './components/BrandSection';
import CTASection from './components/CTASection';
import { featuredArticles } from '@/mocks/zh/article';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '51黑料网',
      url: 'https://www.51heiliao.com',
      description: '51黑料网 - 全网最全吃瓜平台，提供最新明星塌房、网红黑料、博主反差等娱乐爆料资讯。5000万月活用户的吃瓜首选。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.51heiliao.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '51黑料网',
      url: 'https://www.51heiliao.com',
      logo: 'https://www.51heiliao.com/logo.png',
      description: '中国领先的娱乐八卦与网红爆料资讯平台',
    },
    {
      '@type': 'ItemList',
      name: '头条爆料',
      itemListElement: featuredArticles.map((article, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        url: `https://www.51heiliao.com/article/${article.slug}`,
        name: article.title,
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
        <HeroSection />
        <LatestReveal />
        <DailyHighlights />
        <TrendingGrid />
        <ExclusiveReveal />
        <BrandSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}